import { useEffect, useState } from 'react';

import { withSentry } from 'infrastructure/services/sentryLazy';

const STALE_PATTERNS = [
  /Failed to fetch dynamically imported module/i,
  /Importing a module script failed/i,
  /'text\/html' is not a valid JavaScript MIME type/i,
  /Loading chunk [\w-]+ failed/i,
  /ChunkLoadError/i,
];

function isStaleBundle(message: string): boolean {
  return STALE_PATTERNS.some((p) => p.test(message));
}

export function useStaleBundleDetection() {
  const [detected, setDetected] = useState(false);

  useEffect(() => {
    function onError(event: ErrorEvent) {
      if (!isStaleBundle(event.message ?? '')) return;
      event.preventDefault();
      setDetected(true);
      withSentry((Sentry) =>
        Sentry.captureMessage('stale-bundle-detected', {
          level: 'warning',
          tags: { route: location.pathname },
        }),
      );
    }

    function onUnhandledRejection(event: PromiseRejectionEvent) {
      const msg =
        event.reason instanceof Error ? event.reason.message : String(event.reason ?? '');
      if (!isStaleBundle(msg)) return;
      event.preventDefault();
      setDetected(true);
      withSentry((Sentry) =>
        Sentry.captureMessage('stale-bundle-detected', {
          level: 'warning',
          tags: { route: location.pathname },
        }),
      );
    }

    window.addEventListener('error', onError);
    window.addEventListener('unhandledrejection', onUnhandledRejection);

    return () => {
      window.removeEventListener('error', onError);
      window.removeEventListener('unhandledrejection', onUnhandledRejection);
    };
  }, []);

  return { detected };
}
